import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, Stack, Textarea, ModalFooter, Button } from "@chakra-ui/react"
import React, { useState } from "react"
import { useSendFeedbackMutation } from "../api/layoutApi"
import { toast } from "react-toastify"

interface Props {
    isOpen: boolean
    onClose: () => void
}

export function LeaveFeedback(props: Props) {
    const [feedback, setFeedback] = useState('')
    const { isOpen, onClose } = props

    const [sendFeedback, { isLoading }] = useSendFeedbackMutation()

    const handleClose = () => {
        onClose()
        setFeedback('')
    }

    const handleSubmit = async () => {
        const toastId = toast.info('Sending feedback...', {
            style: { padding: '10px 20px' },
            autoClose: false,
            isLoading: true,
            progress: undefined,
        })
        try {
            await sendFeedback({ feedback: feedback }).unwrap()
            toast.update(toastId, {
                render: 'Feedback sent successfully!',
                type: 'success',
                isLoading: false,
                autoClose: 3000,
            })
        } catch (_error) {
            toast.update(toastId, {
                render: `Failed to send feedback`,
                type: 'error',
                isLoading: false,
                autoClose: 3000,
            })
        }
        handleClose()
    }

    return (
        <Modal isOpen={isOpen} onClose={handleClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Leave feedback</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Stack spacing={4}>
                        <Textarea
                            placeholder="Your feedback"
                            value={feedback}
                            onChange={(e) => setFeedback(e.target.value)}
                        />
                    </Stack>
                </ModalBody>
                <ModalFooter>
                    <Button
                        isDisabled={!feedback}
                        isLoading={isLoading}
                        colorScheme="blue"
                        mr={3}
                        onClick={handleSubmit}
                    >
                        Submit
                    </Button>
                    <Button variant="ghost" onClick={onClose}>
                        Cancel
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}